import { memo } from 'react';

import { Tag, type TagProps, useTagVariant } from '@didaskill/ui/design-system';

export type VirtualClassroomTagProps = Omit<TagProps, 'label' | 'variant' | 'light'> & {
  label: string;
};

export const VirtualClassroomTagBase = ({ label, ...props }: VirtualClassroomTagProps) => {
  const variant = useTagVariant(label, {
    exclude: [Tag.VARIANTS.PRIMARY],
  });

  return <Tag {...props} label={label} variant={variant} light />;
};

VirtualClassroomTagBase.displayName = 'VirtualClassroomTag';

export const VirtualClassroomTag = memo(VirtualClassroomTagBase);
